import { FormControl, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import useUpdateOrganizationProposalChecklistItem from "hooks/organization/useUpdateOrganizationProposalChecklistItem";
import { useState } from "react";

interface EditChecklistItemProps {
  item: {
    id: string;
    name: string;
  };
  onCancel: () => void;
}

export default function EditChecklistItem({ item, onCancel }: EditChecklistItemProps) {
  const [name, setName] = useState(item.name);
  const [updateChecklistItem, { loading }] = useUpdateOrganizationProposalChecklistItem();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      updateChecklistItem({
        variables: {
          id: item.id,
          name: name.trim(),
        },
        onCompleted: () => {
          onCancel();
        },
      });
    }
  };

  return (
    <MDBox component="form" onSubmit={handleSubmit} width="100%" p={1}>
      <MDBox display="flex" alignItems="center" mb={2}>
        <MDTypography variant="h6" fontWeight="medium">
          Edit Checklist Item
        </MDTypography>
      </MDBox>
      <MDBox display="flex" gap={2}>
        <FormControl fullWidth>
          <TextField
            label="Item Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            autoFocus
          />
        </FormControl>
        <MDBox display="flex" gap={1}>
          <MDButton
            variant="contained"
            color="success"
            type="submit"
            disabled={loading || !name.trim() || name === item.name}
          >
            Update
          </MDButton>
          <MDButton variant="outlined" color="secondary" onClick={onCancel}>
            Cancel
          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
